import script from "./NewsletterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsletterBar.vue?vue&type=script&setup=true&lang=js"

import "./NewsletterBar.vue?vue&type=style&index=0&id=1a78263a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a78263a"]])

export default __exports__